import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import shopService from 'services/shop';

const initialState = {
  loading: false,
  currentShop: null,
  error: '',
};

/**
 * Fetches the single app shop (first from admin shops paginate).
 * Used for single-vendor (Kamil Store) setup - no multi-shop UI.
 */
export const fetchAppShop = createAsyncThunk(
  'appShop/fetchAppShop',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await shopService.getAll({
        perPage: 1,
        status: 'approved',
      });
      const list = Array.isArray(data) ? data : data?.data ?? [];
      const shop = list[0] ?? null;
      return shop;
    } catch (err) {
      return rejectWithValue(err?.message || 'Failed to load shop');
    }
  },
);

const appShopSlice = createSlice({
  name: 'appShop',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchAppShop.pending, (state) => {
      state.loading = true;
      state.error = '';
    });
    builder.addCase(fetchAppShop.fulfilled, (state, action) => {
      state.loading = false;
      state.currentShop = action.payload;
      state.error = '';
    });
    builder.addCase(fetchAppShop.rejected, (state, action) => {
      state.loading = false;
      state.currentShop = null;
      state.error = action.payload || action.error?.message || '';
    });
  },
});

export default appShopSlice.reducer;

/** Selector: full shop object for APIs and display */
export const selectAppShop = (state) => state.appShop?.currentShop ?? null;

/** Selector: { label, value, uuid } for display and PUT shops/:uuid (single-shop) */
export const selectAppShopOption = (state) => {
  const shop = state.appShop?.currentShop;
  if (!shop) return null;
  const uuid = shop.uuid ?? shop.id;
  return {
    label: shop.translation?.title ?? shop.title ?? String(uuid),
    value: uuid,
    uuid,
  };
};
